import { Component } from '@angular/core';

@Component({
  selector: 'app-sic-ania',
  templateUrl: './sic-ania.component.html',
  styleUrls: ['./sic-ania.component.scss']
})
export class SicAniaComponent {

}
